import ApiClient from 'shared/utils/api-client';
import config from 'exogen-rx/config';

export default new ApiClient(config);
